import BasicTag from './BasicTag.component';

export default BasicTag;
